import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { MessageContainer, VideoPlayer, useLiveStreamURLFetch } from ".";
import { VideoPlayerConfig } from "./config/LiveStreamConfig";

export const LiveStreamContainer = observer(
	function LiveStreamContainer(props: {
		eventId: string;
		location: WidgetLocation;
		config: VideoPlayerConfig;
	}) {
		const liveStreamData = useLiveStreamURLFetch(
			props.eventId,
			props.location
		);

		const t = useTranslation().t;

		if (!liveStreamData.myWidget) {
			return null;
		}

		const infoMsg = liveStreamData.myWidget?.message?.infoMessage;
		const errorMsg = liveStreamData.myWidget?.message?.errorMessage;
		const isLoggedOut = !liveStreamData.user.isLoggedIn;

		if (isLoggedOut || infoMsg || errorMsg) {
			const msg = isLoggedOut
				? t<string>("LIVE_WIDGETS.LIVE_STREAM.NOT_LOGGED_IN")
				: (errorMsg ?? infoMsg ?? "");

			return (
				<div
					className={
						props.location === WidgetLocation.SIDE
							? "u-padd--bottom--xsml"
							: ""
					}
				>
					<MessageContainer
						message={msg}
						isError={!!errorMsg}
						location={props.location}
						customClass="u-mar--bottom--reset"
					/>
				</div>
			);
		}

		if (!liveStreamData.myWidget.url) {
			return (
				<div className="loader loader--stream">
					<div className="loader__spinner loader__spinner--primary loader--stream__spinner" />
				</div>
			);
		}

		return (
			<VideoPlayer
				url={liveStreamData.myWidget.url}
				widget={liveStreamData.myWidget}
				config={props.config}
			/>
		);
	}
);
